export default [
    {
        path: 'exchange/list',
        name: 'content_exchange_list',
        meta: { isCache: true, icon: 'md-cash', hideInMenu: false },
        component: () => import('@/views/content/exchange/exchange-list.vue'),
    },
    {
        path: 'exchange/add',
        name: 'content_exchange_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/content/exchange/exchange-add.vue'),
    },
    {
        path: 'exchange/edit/:id',
        name: 'content_exchange_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/content/exchange/exchange-edit.vue'),
    },
    {
        path: 'exchange/detail/:id',
        name: 'content_exchange_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/content/exchange/exchange-detail.vue'),
    },
];
